import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const FileIcon = styled.i`
  display: inline;
  margin-right: 3px;
`
const Link = styled.a`
  margin-left: 2px;
  &:hover {
    cursor: pointer;
  }
`

const FileLink = props => {
  return (
    <Link href={props.href} rel="noreferrer" target="_blank">
      <FileIcon className="fa fa-file-text-o" />
      {props.text}
    </Link>
  )
}

FileLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string
}

export default FileLink